<template>
  <div class="main">
    <div class="banner-outer">
      <img
        :src="banner8"
        class="banner"
      />
      <img
        :src="btn"
        @click="toBuy()"
        class="btn"
      />
    </div>
    <div
      class="msg-box"
      type="ffffff"
    >
      <div class="title" style="color:#E96023;">
        無料プレゼントをセット
      </div>
      <div class="min-title">
        J-Direct BOXを購入すると<span style="color:#d3161b;">129USD</span>分の無料プレゼント！
      </div>
      <img
        :src="msg0"
        class="main-image"
      >
    </div>
    <div
      class="msg-box"
      type="white"
      style="padding-top:70px;padding-bottom:74px;"
    >
      <div class="title">
        J-DIRECT BOX 同梱一覧
      </div>
      <img
        :src="msg5"
        class="main-image"
      />
    </div>
    <div
      class="msg-box"
      type="ffffff"
      style="padding-top:53px;padding-bottom:69px;"
    >
      <div class="title">
        製品仕様
      </div>
      <img
        :src="msg1"
        class="min-image"
      />
    </div>
  </div>
</template>
<script>
import { banner8, btn, msg5 } from '../../../images/box/index'
import { msg0, msg1 } from '../../../images/buy/index'
export default {
  data () {
    return {
      banner8,
      btn,
      msg0,
      msg5,
      msg1
    }
  },
  methods: {
    toBuy () {
      this.$emit('toBuy')
    }
  }
}
</script>
<style scoped>
.main {
  width: 100%;
  min-width: 1100px;
}
.banner-outer {
  width: 100%;
  position: relative;
  min-width: 1100px;
  margin: 0 auto;
}
.banner {
  width: 100%;
  height: auto;
  display: block;
}
.banner1 {
  width: 1100px;
  margin: 0 auto;
  height: auto;
  display: block;
}
.btn {
  cursor: pointer;
  position: absolute;
  width: 12%;
  bottom: 20%;
  left: 21%;
}
.msg-box {
  width: 100%;
  min-width: 1100px;
  box-sizing: border-box;
  padding-top: 50px;
  text-align: center;
}
.msg-box {
  width: 100%;
  min-width: 1100px;
  text-align: center;
  padding: 68px 0;
}
.msg-box .title {
  font-size: 35px;
  font-weight: bold;
}
.msg-box .min-title {
  padding-bottom: 41px;
  font-size: 25px;
  font-weight: bold;
}
.msg-box .main-image {
  display: block;
  width: 1100px;
  margin: 30px auto;
}
.msg-box[type='white'] {
  background: #f1f1f1;
  color: #222222;
}
.msg-box[type='allorange'] {
  background: #e9571d;
  color: #222222;
}
.msg-box[type='orange'] {
  background: #ebebeb;
  color: #ff6709;
}
.msg-box[type='ffffff'] {
  background: #ffffff;
  color: #222222;
}
.msg-box[type='dark'] {
  background: #14192d;
  color: #fff;
  padding-bottom: 0;
}
.msg-box[type='dark'] .main-image {
  width: 80%;
  min-width: 1000px;
  margin: 50px auto;
  margin-bottom: 0;
}
.msg-box[type='linear'] {
  background: linear-gradient(-49deg, #03b6da, #2d36bf);
  color: #fff;
}
.msg-box[type='white'] .min-title {
  color: #434343;
}
.msg-box[type='orange'] .min-title {
  color: #434343;
}
.min-image {
  display: block;
  width: 900px;
  margin: 0 auto;
  margin-top: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/buy/modules/main.vue